import React, { useEffect, useState } from "react";
import { Input } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import "./searchBar.css";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setUserSearchResult, setSearchText } from "../../../Redux/actions/app";
import { BLACK, DARKMAIN, PRIMARYMAIN, SECONDARYDARK, SECONDARYMAIN, WHITE } from "../../../Theme/colorConstant";

function SearchBar() {

  const { auth_user, isNightMode } = useSelector((store) => {
    return {
      auth_user: store.auth.auth_user || {},
      isNightMode: store.app.mode || false
    }
  });
  const [users, setUsers] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    axios
      .post("/api/searchUser", {
        loginuser_name: auth_user?.elsemployees_empid,
        input: users,
        user_id: auth_user?.elsemployees_empid,
      })
      .then((res) => {
        dispatch(setUserSearchResult(res.data.records));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [auth_user?.elsemployees_empid, dispatch, users]);
  return (
    <div className="searchBar" style={{ border: isNightMode ? `1px solid ${SECONDARYDARK}` : `1px solid ${SECONDARYDARK}`, background: isNightMode ? DARKMAIN : WHITE }}>
      {users ? (
        <ClearIcon
          style={{ color: isNightMode ? WHITE : PRIMARYMAIN }}
          onClick={() => {
            setUsers("");
            dispatch(setSearchText(""));
          }}
        />
      ) : (
        <SearchIcon style={{ color: isNightMode ? SECONDARYDARK : PRIMARYMAIN }} />
      )}
      <input
        style={{ background: isNightMode && DARKMAIN, color: isNightMode ? SECONDARYMAIN : `${BLACK}`, fontSize: '15px', marginLeft: '0.5rem' }}
        className="searchBarInput"
        placeholder="Search People"
        value={users}
        onChange={(e) => {
          setUsers(e.target.value);
          dispatch(setSearchText(e.target.value));
        }}
      />

    </div>
  );
}

export default React.memo(SearchBar);
